import React from 'react';
import './CircleProgressBar.css';

export default function CircleProgressBar(props) {
    const progressBarClass = `progress-bar-percent ${props.class}`

    return (
        <div className="progress-bar-box">
        <div className={progressBarClass}>
            <svg className="progress-bar-svg">
                <circle cx="30" cy="30" r="30"></circle>
                <circle cx="30" cy="30" r="30"></circle>
            </svg>
            <div className="progress-bar-number">
                <div>{props.precentage}<span>%</span></div>
            </div>
        </div>
        <span className="progress-bar-text">{props.name}</span>
    </div>
    )
}
